"use client";
// @ts-strict-ignore
import styled from "styled-components";

export const BreadCrumbBox = styled.div`
  width: 100%;
  display: flex;
  margin: 0px auto 0px;
  max-width: 100%;
  span {
    width: auto;
    display: flex;
    &:last-child {
      a {
        padding-right: 0px;
        &:after {
          display: none;
        }
      }
    }
    a {
      padding-right: 15px;
      position: relative;
      margin-right: 6px;
      &:after {
        position: absolute;
        content: ">";
        right: 0px;
        top: 0px;
        width: auto;
        height: auto;
      }
      p {
        margin: 0px;

   
    }
  }
`;

export const LinkBox = styled.div`
  width: 100%;
  display: flex;
  & > a:first-child {
    p.firstBreadcrumb {
      padding-right: 15px;
      position: relative;
      margin-right: 6px;
      text-decoration: none;

      &:before {
        position: absolute;
        content: "";
        left: 0px;
        bottom: 1px;
        width: calc(100% - 15px);
        height: 1px;
      }
      &:after {
        position: absolute;
        content: ">";
        right: 0px;
        top: -1px;
        width: auto;
        height: auto;
        font-size: 17px;
      }
    }
  }
`;
